var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"color":_vm.getStallholderColor(_vm.type),"dark":""}},on),[_vm._v(_vm._s(_vm.type.charAt(0).toUpperCase()))])]}}],null,false,1601858543)},[_c('span',[_vm._v(_vm._s(_vm.type))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }